import React, { useEffect, useState } from "react";
import axios from "axios";

const SERVER_URL = "https://allinone-clone-7d5d795e98ce.herokuapp.com";

const FeatureTwo = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/feature-two`);
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Failed to load feature section:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return null;
  if (!data || !data.isActive) return null;

  return (
    <>
      <section className="how-it-works-section position-relative overflow-hidden py-5">
        
        {/* Modern Dark Backgrounds with subtle ambient glows */}
        <div className="bg-absolute bg-dark-base"></div>
        <div className="ambient-glow glow-primary"></div>
        <div className="ambient-glow glow-secondary"></div>

        <div className="container-xl position-relative z-1 mt-5 pt-lg-5 pb-5 px-xl-5">
          
          {/* Premium Section Title */}
          <div className="row justify-content-center text-center mb-5 pb-lg-5">
            <div className="col-lg-8 wow fadeInUp">
              <div className="badge-wrapper mb-4">
                <span className="badge-premium d-inline-flex align-items-center px-3 py-2 rounded-pill border border-white-10 glass-panel tracking-wider text-uppercase shadow-sm">
                  <span className="badge-dot me-2"></span>
                  <span className="text-secondary fw-semibold text-xs">{data.subTitle || "HOW IT WORKS"}</span>
                </span>
              </div>
              
              <h2 className="display-3 fw-bolder text-white title-glow mb-4" style={{ letterSpacing: "-0.04em", lineHeight: "1.15" }}>
                {data.mainTitle || "Create Content in 3 Simple Steps"}
              </h2>
            </div>
          </div>

          {/* Staggered Vertical Timeline Layout */}
          <div className="timeline-container position-relative mt-5">
            
            {/* The Central Animated Laser Line (Desktop Only) */}
            <div className="d-none d-lg-block position-absolute start-50 translate-middle-x z-0" style={{ top: "0", bottom: "0", width: "2px", background: "rgba(255,255,255,0.05)" }}>
              <div className="laser-line-vertical w-100"></div>
            </div>

            <div className="container-fluid px-0">
              {data.steps && data.steps.map((step, index) => {
                const isEven = index % 2 === 0;
                
                return (
                  <div key={step.id || index} className="row align-items-center justify-content-between position-relative timeline-row wow fadeInUp" data-wow-delay="0.2s">
                    
                    {/* Desktop Center Node */}
                    <div className="position-absolute top-50 start-50 translate-middle d-none d-lg-flex align-items-center justify-content-center z-2 pointer-events-none" style={{ width: "80px", height: "80px" }}>
                      <div className="timeline-node rounded-circle d-flex align-items-center justify-content-center fs-4 fw-bold text-white shadow-premium glass-panel border border-white-10">
                        {index + 1}
                      </div>
                    </div>

                    {/* Dotted Connector Line (Desktop Only) */}
                    <div className="d-none d-lg-block position-absolute top-50 translate-middle-y z-1" style={{
                      borderTop: "2px dashed rgba(139, 92, 246, 0.4)",
                      ...(isEven ? {
                        right: "calc(50% + 40px)",
                        width: "calc(8.333% + 3rem - 40px)"
                      } : {
                        left: "calc(50% + 40px)",
                        width: "calc(8.333% + 3rem - 40px)"
                      })
                    }}></div>

                    {/* Content Column */}
                    <div className={`col-lg-5 ${isEven ? "text-lg-end pe-lg-5" : "order-lg-2 ps-lg-5"} mb-4 mb-lg-0`}>
                      <div className="timeline-card p-4 p-lg-5 rounded-4 border border-white-10 glass-panel position-relative overflow-hidden group shadow-premium">
                        
                        {/* Huge Background Number */}
                        <div className={`position-absolute top-50 ${isEven ? "end-0 translate-middle-y me-n4" : "start-0 translate-middle-y ms-n4"} pointer-events-none step-number-bg`} style={{ opacity: 0.03 }}>
                          0{index + 1}
                        </div>
                        
                        <div className="position-relative z-1">
                          <h3 className="h3 text-white mb-3 fw-bolder" style={{ letterSpacing: "-0.02em" }}>{step.title}</h3>
                          <p className="text-secondary mb-0" style={{ lineHeight: "1.7", fontSize: "1.1rem" }}>{step.description}</p>
                        </div>
                        
                        {/* Interactive Hover Glow */}
                        <div className="position-absolute top-50 start-50 translate-middle w-100 h-100 pointer-events-none opacity-0 card-glow transition-opacity z-0"></div>
                      </div>
                    </div>

                    {/* Empty Column for Desktop Alignment */}
                    <div className={`col-lg-5 ${isEven ? "order-lg-2 ps-lg-5" : "text-lg-end pe-lg-5"} d-none d-lg-block`}>
                      {/* Decorative abstract elements to fill empty space */}
                      <div className={`d-flex ${isEven ? "justify-content-start" : "justify-content-end"} align-items-center h-100 opacity-50`}>
                        <div className="rounded-circle border border-white-10 position-relative" style={{ width: "120px", height: "120px", borderStyle: "dashed !important", animation: isEven ? "spin 20s linear infinite" : "spin 20s linear infinite reverse" }}>
                           <div className="position-absolute top-50 start-50 translate-middle rounded-circle bg-indigo opacity-20 blur-xl" style={{ width: "60px", height: "60px", background: "rgba(99, 102, 241, 0.4)" }}></div>
                        </div>
                      </div>
                    </div>

                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <style jsx>{`
          .how-it-works-section {
            background-color: #020617; /* Slate 950 base */
            font-family: 'Inter', system-ui, sans-serif;
          }
          
          .bg-absolute {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
          }
          
          .bg-dark-base {
            background-image: 
              linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);
            background-size: 60px 60px;
            background-position: center center;
            opacity: 0.5;
            mask-image: radial-gradient(ellipse at bottom, black 30%, transparent 80%);
            -webkit-mask-image: radial-gradient(ellipse at bottom, black 30%, transparent 80%);
          }

          .ambient-glow {
            position: absolute;
            border-radius: 50%;
            filter: blur(120px);
            z-index: 0;
            opacity: 0.3;
            pointer-events: none;
            animation: float-glow 25s ease-in-out infinite alternate;
          }

          .glow-primary {
            width: 600px;
            height: 600px;
            background: rgba(99, 102, 241, 0.15); /* Indigo */
            top: 10%;
            left: -100px;
            animation-delay: -5s;
          }

          .glow-secondary {
            width: 500px;
            height: 500px;
            background: rgba(139, 92, 246, 0.15); /* Violet */
            bottom: -100px;
            right: -100px;
            animation-delay: -15s;
          }

          @keyframes float-glow {
            0% { transform: translate(0, 0) scale(1); }
            33% { transform: translate(30px, -50px) scale(1.1); }
            66% { transform: translate(-20px, 20px) scale(0.9); }
            100% { transform: translate(0, 0) scale(1); }
          }

          .glass-panel {
            background: rgba(15, 23, 42, 0.4);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
          }

          .border-white-10 {
            border-color: rgba(255, 255, 255, 0.08) !important;
          }

          .text-secondary {
            color: #94a3b8 !important; /* Slate 400 */
          }
          
          .text-xs {
            font-size: 0.75rem;
          }

          .tracking-wider {
            letter-spacing: 0.05em;
          }

          .badge-premium {
            background: linear-gradient(180deg, rgba(30, 41, 59, 0.7) 0%, rgba(15, 23, 42, 0.7) 100%);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1);
          }

          .badge-dot {
            width: 8px;
            height: 8px;
            background-color: #8b5cf6; /* Violet 500 */
            border-radius: 50%;
            box-shadow: 0 0 8px #8b5cf6;
            animation: pulse-dot 2s infinite;
          }

          @keyframes pulse-dot {
            0% { box-shadow: 0 0 0 0 rgba(139, 92, 246, 0.4); }
            70% { box-shadow: 0 0 0 6px rgba(139, 92, 246, 0); }
            100% { box-shadow: 0 0 0 0 rgba(139, 92, 246, 0); }
          }

          .title-glow {
            text-shadow: 0 0 40px rgba(255, 255, 255, 0.1);
          }

          .pointer-events-none {
            pointer-events: none;
          }
          .transition-opacity {
            transition: opacity 0.4s ease;
          }

          /* Vertical Laser Line Animation */
          .laser-line-vertical {
            height: 200%;
            background: linear-gradient(180deg, transparent, #8b5cf6, transparent);
            animation: moveLaserVertical 4s linear infinite;
            opacity: 0.7;
          }
          @keyframes moveLaserVertical {
            0% { transform: translateY(-50%); }
            100% { transform: translateY(0%); }
          }

          /* Timeline Row spacing */
          .timeline-row {
            margin-bottom: 6rem;
          }
          .timeline-row:last-child {
            margin-bottom: 0;
          }

          /* Timeline Node */
          .timeline-node {
            width: 56px;
            height: 56px;
            background: rgba(15, 23, 42, 0.8);
            box-shadow: 0 0 20px rgba(0,0,0,0.5), inset 0 1px 1px rgba(255,255,255,0.1);
            transition: all 0.4s ease;
          }
          .timeline-row:hover .timeline-node {
            background: rgba(139, 92, 246, 0.2);
            border-color: #8b5cf6 !important;
            box-shadow: 0 0 30px rgba(139, 92, 246, 0.4), inset 0 1px 1px rgba(255,255,255,0.2);
            color: #c084fc !important;
          }

          /* Timeline Card Premium Styles */
          .timeline-card {
            transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1), border-color 0.5s ease, box-shadow 0.5s ease;
          }

          .shadow-premium {
            box-shadow: 
              0 10px 30px -10px rgba(0, 0, 0, 0.5),
              0 0 0 1px rgba(255, 255, 255, 0.02);
          }

          .timeline-card:hover {
            transform: translateY(-8px);
            border-color: rgba(139, 92, 246, 0.4) !important;
            box-shadow: 
              0 25px 50px -12px rgba(0, 0, 0, 0.8),
              0 0 0 1px rgba(255, 255, 255, 0.1),
              0 0 40px rgba(139, 92, 246, 0.15);
          }

          .card-glow {
            background: radial-gradient(circle at center, rgba(139, 92, 246, 0.1) 0%, transparent 70%);
          }
          .timeline-card:hover .card-glow {
            opacity: 1 !important;
          }

          /* Huge Background Number */
          .step-number-bg {
            font-size: 14rem;
            font-weight: 900;
            line-height: 1;
            color: #ffffff;
            transition: color 0.4s ease, transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
          }
          .timeline-card:hover .step-number-bg {
            color: #8b5cf6;
            opacity: 0.08 !important;
            transform: scale(1.1);
          }

          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </section>
    </>
  );
};

export default FeatureTwo;